import { stylePresentation, normalizeStyleValue } from '@mts/shared/blockStyles';
import { propertiesForNode } from '@mts/shared/blockDesign';
import { COLUMN_WIDTHS } from '@mts/shared/containerLayout';

export const clamp = (value, min, max, fallback) => Number.isFinite(Number(value)) ? Math.max(min, Math.min(max, Number(value))) : fallback;
export function blockPresentation(type, attrs = {}) {
  const supported = propertiesForNode(type);
  const presentation = stylePresentation(attrs.styleSettings, supported.length ? supported : undefined);
  const style = { ...presentation.styleObject };
  const legacy = attrs.builderSettings || {};
  for (const [key, value] of Object.entries({ fontSize:legacy.fontSize ? `${legacy.fontSize}px` : null, textAlign:attrs.textAlign || legacy.alignment, backgroundColor:attrs.backgroundColor, borderColor:attrs.borderColor, borderWidth:attrs.borderWidth ? `${clamp(attrs.borderWidth,0,20,0)}px` : null })) {
    const safe = normalizeStyleValue(key, value);
    if (safe && style[key] == null) style[key] = safe;
  }
  if (style.borderWidth && style.borderColor) style.borderStyle ||= 'solid';
  if (legacy.colorToken && /^[a-z][A-Za-z]+$/.test(legacy.colorToken)) style.color ||= `var(--${legacy.colorToken.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)})`;
  return { className:presentation.className, style,
    'data-layout-sizing':['fit','grow','fixed'].includes(attrs.layoutSizing) ? attrs.layoutSizing : undefined,
    'data-layout-width':attrs.layoutSizing === 'fixed' && COLUMN_WIDTHS.includes(attrs.layoutWidth) ? attrs.layoutWidth : undefined };
}
export function imagePresentation(attrs = {}) {
  const root = blockPresentation('image', attrs);
  const width = clamp(attrs.width ?? attrs.builderSettings?.width ?? 100,10,100,100);
  const crop = { objectFit:root.style.objectFit || 'cover', objectPosition:root.style.objectPosition || `${clamp(attrs.focalX ?? 50,0,100,50)}% ${clamp(attrs.focalY ?? 50,0,100,50)}%` };
  const zoom = clamp(attrs.zoom ?? 100,100,300,100);
  if (zoom !== 100) { crop.transform = `scale(${zoom / 100})`; crop.transformOrigin = crop.objectPosition; }
  return { root:{ ...root, style:{ width:`${width}%`, flex:`0 0 ${width}%`, ...root.style } }, crop };
}
export const themeToken = (value, fallback) => /^[a-z][A-Za-z]*$/.test(value || '') ? `var(--${value.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)})` : `var(--${fallback})`;
